import { createContext, useContext, useState } from 'react';
import { IGlobalContextProvider, IGlobalPageState } from './IGlobalContext';
import { NotificationDrawerControls } from '@echotex/business-modules';

const DummyMethod = () => {};

const GlobalContext = createContext<IGlobalPageState>({
  notificationDrawerContainerOpenFor: null,
  updateNotificationDrawerContainerOpenFor: DummyMethod,
  notificationDrawerContainerOpenState: false,
  updateNotificationDrawerContainerOpenState: DummyMethod,
});

GlobalContext.displayName = 'GlobalPageStateContext';

// The hook to expose the context value
export const useGlobalPageStateContext = () => {
  return useContext(GlobalContext);
};

// The context provider
export const GlobalContextProvider = ({ children }: IGlobalContextProvider): JSX.Element => {
  const [notificationDrawerContainerOpenState, updateNotificationDrawerContainerOpenState] = useState<boolean>(false);
  const [notificationDrawerContainerOpenFor, updateNotificationDrawerContainerOpenFor] =
    useState<NotificationDrawerControls | null>(null);

  return (
    <GlobalContext.Provider
      value={{
        notificationDrawerContainerOpenState,
        updateNotificationDrawerContainerOpenState,
        notificationDrawerContainerOpenFor,
        updateNotificationDrawerContainerOpenFor,
      }}>
      {children}
    </GlobalContext.Provider>
  );
};
